module.exports = __webpack_public_path__ + "img/big_1_48.f9fe0d10.png";